import React, { SVGProps } from 'react'
const SvgCollapse = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || 'var(--color-cta)'}
      d="M18.5 11.75h-12a.75.75 0 1 0 0 1.5h12a.75.75 0 0 0 0-1.5Z"
    />
  </svg>
)
export default SvgCollapse
